import { ProductionUnit } from "@tosize/ui";
import type { Input } from "../types/shape";

/**
 * @param display
 * 1 = excluding tax,
 * 2 = including tax,
 * 3 = including tax and including tax
 */
export type Money = {
	currency: string;
	display: 1 | 2 | 3 | PriceDisplay;
	includingTax: number;
	excludingTax: number;
};

enum PriceDisplay {
	Both = "BOTH",
	ExcludingTax = "EXCLUDING_TAX",
	IncludingTax = "INCLUDING_TAX",
}

export function getMoneyValue(money: Money) {
	const isDisplay =
		typeof money.display === "number"
			? money.display === 2
			: money.display === PriceDisplay.IncludingTax;

	return isDisplay ? money.includingTax : money.excludingTax;
}

export const parseNumber = (val: unknown) => (val === "" ? undefined : Number(val));
export const parseToggleableNumber = (val: unknown) => (val === "null" ? 0 : Number(val));
export const formattConstraint = (input: number) => Math.max(input, 0);

export function getMaxBasedOnUnit(max: Input["max"], unit?: ProductionUnit) {
	if (typeof max === "number") {
		return max;
	}

	if (unit) {
		return max[unit] ?? max[ProductionUnit.M2] ?? 0;
	}

	return max[ProductionUnit.M2] ?? 0;
}
